import type { CSSProperties, FC, ReactElement } from 'react';

import testId from '@snowit/utils/testId';

import Typo from '../../Typography/Typo';

import cx from 'classnames';
import s from './BadgeNotify.module.scss';

interface IBadgeNotify {
  /** Text contained in the badge label */
  label?: string | number;
  size?: number;
  /** The color of badge label background  */
  color?: string;
  /** If true show pulse animation  */
  pulse?: boolean;
  /** Add a classname to the badge label */
  className?: string;
  /** Id of the component */
  id?: string;
  /** Jest/Cypress test string */
  test?: string;
}

/**
 Badge Notify is an info visual elements used for items that need a visual notification.
*/
const BadgeNotify: FC<IBadgeNotify> = (props: IBadgeNotify): ReactElement => {
  const { label, size = 1.5, color = 'var(--c-text)', pulse = false, id, className, test } = props;

  return (
    <div
      id={id}
      className={cx(s.badgeNotify, className, { [s.pulse]: pulse })}
      style={
        {
          '--size': size,
          '--badge-color': color,
        } as CSSProperties
      }
      {...testId(test)}
    >
      {label && <Typo className={s.label} text={label} size={'xs'} color={'white'} />}
    </div>
  );
};

export default BadgeNotify;
